import { render, staticRenderFns } from "./Dialog_CreateMessage.vue?vue&type=template&id=df624460&scoped=true&"
import script from "./Dialog_CreateMessage.vue?vue&type=script&lang=js&"
export * from "./Dialog_CreateMessage.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_CreateMessage.vue?vue&type=style&index=0&id=df624460&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df624460",
  null
  
)

export default component.exports